import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import LogoUploader from './logoUploader';
import * as styles from './Diy.module.css';

const defaultFormData = { logo: '' };

const Logo = ({ formData = defaultFormData, handleInputChange }) => {
  const [logo, setLogo] = useState(formData.logo);

  const handleLogoUpload = logoUrl => {
    setLogo(logoUrl);
    handleInputChange({ target: { name: 'logo', value: logoUrl } });
  };

  useEffect(() => {
    setLogo(formData.logo);
  }, [formData.logo]);

  return (
    <>
      <Form.Group className="mb-3" controlId="logo">
        <Form.Label className={styles.logoLabel}>
          Import logo from url
        </Form.Label>
        <Form.Control
          name="logo"
          type="text"
          className={styles?.name}
          value={logo}
          onChange={handleInputChange}
          placeholder="Enter URL"
        />
        <LogoUploader onLogoUpload={handleLogoUpload} />
      </Form.Group>
    </>
  );
};

export default Logo;
